import { Action, IOWidget, mk_widget } from 'widgets-for-react'
import React from 'react'
import { CMSState, Url } from '../../../../cms/blocks/types.gen'
import { link, getClassName } from '../../../../cms/blocks/utils.gen'
import { PublicSite_CustomPageData } from '../../../application.mod'
import { gtmPush, decodeHTMLEntities } from '../../../../../helpers'
import { PublicSiteState } from '../../../../public_site.main.mod'

export type CtaBlockProps = {
  title: string
  intro: string
  buttons: 'none' | 'primary' | 'primary_secondary'
  primary_button?: ({
    kind: 'link'
    is_link_external: boolean
    target: '_blank' | '_self'
    url: Url
  }) & { title: string }
  secondary_button?: ({
    kind: 'link'
    is_link_external: boolean
    target: '_blank' | '_self'
    url: Url
  }) & { title: string }

  show_in_page_navigation: boolean
  navigation_title: string
}

export type CtaBlockStyle = Partial<{
  block_classname: string
  inner_classname: string
  header_classname: string
  title_classname: string
  content_classname: string
  text_classname: string
  footer_classname: string
  clickable_primary_classname: string
  clickable_secondary_classname: string
}>

export function CtaBlock<customBlockData, extra_images>(
  props: CtaBlockProps,
  options?: { style?: CtaBlockStyle; key?: string }
): (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => IOWidget<PublicSiteState, Action<CMSState<customBlockData, extra_images, PublicSite_CustomPageData>>> {
  return (s: CMSState<customBlockData, extra_images, PublicSite_CustomPageData>) => (public_state: PublicSiteState) =>
    mk_widget({
      run: _ => (
        <section
          id={props.navigation_title}
          className={getClassName(options, 'block_classname', 'container')}
          key={options && options.key ? options.key : 'cta-block'}
        >
          <div className={getClassName(options, 'inner_classname', 'py-5')}>
            <header className={getClassName(options, 'header_classname', '')}>
              <h2 className={getClassName(options, 'title_classname', 'text-center mb-3')}>{decodeHTMLEntities(props.title)}</h2>
            </header>

            <div className={getClassName(options, 'content_classname', '')} dangerouslySetInnerHTML={{ __html: props.intro }} />
            {props.buttons !== 'none' ? (
              <footer className={getClassName(options, 'footer_classname', 'text-center')}>
                {props.primary_button && props.primary_button.title && props.primary_button.url
                  ? link(
                    props.primary_button,
                    { classname: getClassName(options, 'clickable_primary_classname', 'btn btn-dark') },
                    props.primary_button.title,
                    () => gtmPush({ category: 'CTA', action: props.primary_button.title, label: props.primary_button.url })
                  )
                  : null}
                {props.secondary_button &&
                  props.secondary_button.title &&
                  props.secondary_button.url &&
                  props.buttons === 'primary_secondary'
                  ? link(
                    props.secondary_button,
                    { classname: getClassName(options, 'clickable_secondary_classname', 'btn btn-link ml-2') },
                    props.secondary_button.title,
                    () => gtmPush({ category: 'CTA', action: props.primary_button.title, label: props.primary_button.url })
                  )
                  : null}
              </footer>
            ) : null}
          </div>
        </section>
      )
    })
}



// WEBPACK FOOTER //
// ./Client/components/public_site/blocks/custom_blocks/widgets/ctaBlock.tsx